import React from 'react';
import { Alert, Button, Box } from '../ui';

interface ManagerViewIndicatorProps {
  onEnroll?: () => void;
}

export const ManagerViewIndicator: React.FC<ManagerViewIndicatorProps> = ({ onEnroll }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning" sx={{ alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <strong>Editing</strong> - You can edit this course. Your progress is not being tracked.
          </Box>
          {onEnroll && (
            <Button size="small" variant="outlined" onClick={onEnroll} sx={{ ml: 2 }}>
              Enroll as Student
            </Button>
          )}
        </Box>
      </Alert>
    </Box>
  );
};
